module.exports = "<div class=\"modal\">\n  <header>\n    <h4 class=\"title\">{{title}}</h4>\n\n    <button (click)=\"close()\">\n      <app-icon name=\"cross\"></app-icon>\n    </button>\n  </header>\n\n  <div class=\"content\">\n    <ng-content></ng-content>\n  </div>\n\n  <div *ngIf=\"noActions === false\" class=\"actions\">\n    <button class=\"cancel\" (click)=\"close()\">Cancel</button>\n    <button class=\"done\" (click)=\"submit()\">Save</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/generic/modal/modal.component.html
// module id = ../../../../../src/app/generic/modal/modal.component.html
// module chunks = main